// extracted by mini-css-extract-plugin
export default {"wrapper":"Empty_wrapper__so+Iy","title":"Empty_title__0dpMF","subtitle":"Empty_subtitle__6+trP","btnWrapper":"Empty_btnWrapper__VsEm5"};